/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_handleSplitSamlSsoPost } from '../models/Body_handleSplitSamlSsoPost';
import type { SskSigningFailureReceipt } from '../models/SskSigningFailureReceipt';
import type { SskSigningFailureReport } from '../models/SskSigningFailureReport';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SamlSskService {
    /**
     * Get split SAML metadata
     * Get unsigned split SAML IdP metadata XML
     * @param download Return as downloadable file
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getSplitSamlMetadata(
        download: boolean = false,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/saml-ssk/metadata',
            query: {
                'download': download,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Handle split SAML SSO GET request
     * Handle split SAML SSO request via GET method (HTTP-Redirect binding)
     * @param samlRequest Base64 encoded SAML request
     * @param relayState Relay state
     * @param sigAlg Signature algorithm
     * @param signature Request signature
     * @returns void
     * @throws ApiError
     */
    public static handleSplitSamlSsoGet(
        samlRequest: string,
        relayState?: (string | null),
        sigAlg?: (string | null),
        signature?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/saml-ssk/sso',
            query: {
                'SAMLRequest': samlRequest,
                'RelayState': relayState,
                'SigAlg': sigAlg,
                'Signature': signature,
            },
            errors: {
                302: `Successful Response`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Handle split SAML SSO POST request
     * Handle split SAML SSO request via POST method (HTTP-POST binding)
     * @param formData
     * @returns void
     * @throws ApiError
     */
    public static handleSplitSamlSsoPost(
        formData: Body_handleSplitSamlSsoPost,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/saml-ssk/sso',
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                302: `Successful Response`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Report a browser-side SSK signing failure
     * Records an application-scoped failure event for the signed-in user so tenant admins can see why the second-share signing did not complete, and answers with the signed-in username for the failure screen.
     * @param requestBody
     * @param mfaAuthenticatedSession
     * @returns SskSigningFailureReceipt Successful Response
     * @throws ApiError
     */
    public static reportSskSigningFailure(
        requestBody: SskSigningFailureReport,
        mfaAuthenticatedSession?: (string | null),
    ): CancelablePromise<SskSigningFailureReceipt> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/saml-ssk/signing-failure',
            cookies: {
                'mfa_authenticated_session': mfaAuthenticatedSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `No live IdP session`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Handle split SAML logout GET request
     * Split SAML Single Logout (not yet implemented)
     * @returns string Successful Response
     * @throws ApiError
     */
    public static handleSplitSamlLogout(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/saml-ssk/slo',
        });
    }
}
